export default {"src":"/_next/static/media/404.338384ca.gif","height":700,"width":700,"blurWidth":0,"blurHeight":0};